import React from 'react';
import './SafetySecurityFilmsPage.css';

const SafetySecurityFilmsPage = () => (
  <main className="safety-films-main">
    <section className="safety-films-hero">
      <h1>Safety & Security Films</h1>
    </section>
    <section className="safety-films-content">
      <h2>Unseen Protection. Visible Peace of Mind.</h2>
      <p>At Derma Protec Films, safety isn't an afterthought — it's a foundation. Our Safety & Security Window Films provide an invisible layer of defense designed to protect your property, people, and peace of mind. Whether you're dealing with natural disasters, break-in attempts, or accidental impacts, these films reinforce your glass, helping to hold it together and minimize risk.</p>
      <p>Crafted using advanced multi-layered polyester technology, our films are available in a range of thicknesses, shades, and finishes to suit various security and aesthetic needs — from discreet clear installations to solar control tinted versions.</p>
      
      <div className="safety-films-img-center">
        <img src="https://i.postimg.cc/s2BZNFp6/safety-security-derma.png" alt="Safety & Security Films Derma Protec" className="safety-films-content-img" />
      </div>
      
      <div className="safety-films-img-center">
        <img src="https://i.postimg.cc/HkkMb8jC/safety-security-2-derma.png" alt="Safety & Security Films Derma Protec Example 2" className="safety-films-content-img" />
      </div>

      <div className="specs-table-wrapper">
        <h2>Safety & Security Film Specifications</h2>
        <table className="specs-table">
          <thead>
            <tr>
              <th>Model</th>
              <th>VLT</th>
              <th>IRR</th>
              <th>UVR</th>
              <th>Material</th>
              <th>Thickness</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DPSF 02</td>
              <td>89%</td>
              <td>10%</td>
              <td>15%</td>
              <td>PET</td>
              <td>2 Mil</td>
            </tr>
            <tr>
              <td>DPSF 04</td>
              <td>89%</td>
              <td>11%</td>
              <td>20%</td>
              <td>PET</td>
              <td>4 Mil</td>
            </tr>
            <tr>
              <td>DPSF 08</td>
              <td>89%</td>
              <td>10%</td>
              <td>23%</td>
              <td>PET</td>
              <td>8 Mil</td>
            </tr>
            <tr>
              <td>DPSF 12</td>
              <td>89%</td>
              <td>10%</td>
              <td>26%</td>
              <td>PET</td>
              <td>12 Mil</td>
            </tr>
            <tr>
              <td>DPSF 16</td>
              <td>89%</td>
              <td>9%</td>
              <td>95%</td>
              <td>PET</td>
              <td>16 Mil</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <h2>Key Benefits</h2>
      <ul>
        <li><strong>Break-In & Theft Resistance</strong><br />Designed as a physical barrier on vulnerable entry points such as storefronts, ground-level windows, and door glass, these films delay forced entry and deter vandalism. The anti-smash and grab feature frustrates intruders, reducing theft and property damage.</li>
        <li><strong>Shatter Containment</strong><br />In the event of earthquakes, strong winds, or accidental impact, shattered glass can cause injury or leave buildings exposed. Our safety films are engineered to hold glass fragments in place, greatly reducing the chance of harm or intrusion.</li>
        <li><strong>Storm & Impact Protection</strong><br />These films enhance the structural integrity of glass, helping resist flying debris, wind pressure, and shockwaves — keeping windows and doors intact during extreme weather events.</li>
        <li><strong>UV Blocking & Solar Comfort</strong><br />All safety films block up to 99% of harmful UV rays, helping preserve interior furnishings while reducing the risk of sun-related skin exposure. Tinted versions also help with glare reduction and solar heat control, improving comfort and energy efficiency.</li>
        <li><strong>Low-Profile Protection</strong><br />Maintain your space's natural light and aesthetics with clear or lightly tinted films. Despite their discreet appearance, they offer heavy-duty protection, with available thicknesses ranging from 2 mil to 16 mil for varied security needs.</li>
        <li><strong>Versatile Applications</strong><br />Our Safety & Security films are ideal for:
          <ul>
            <li>Homes and Villas</li>
            <li>Retail Storefronts</li>
            <li>Schools, Colleges & Universities</li>
            <li>Hospitals and Clinics</li>
            <li>Commercial Offices & Corporate Spaces</li>
            <li>Government Buildings and High-Security Sites</li>
            <li>Parking Garages & Basements</li>
          </ul>
        </li>
        <li><strong>Long-Term Warranty Coverage</strong><br />Enjoy confidence in every installation with a warranty up to 5 years for commercial applications, ensuring durability and performance over time.</li>
      </ul>
      <h2>Why Choose Safety and Security Films from Derma Protec?</h2>
      <p>Every Derma Protec Safety Film is manufactured with optical clarity, high tensile strength, and precision adhesive bonding. Rigorously tested against international safety standards, our films are installed by certified professionals to ensure proper performance.</p>
      <p>We don't just reinforce your windows — we reinforce your security. Whether it's defending your shop from a smash-and-grab or keeping your family safe from broken glass during a storm, Derma Protec Safety & Security Films act as your building's first line of defense — quietly, effectively, and reliably.</p>
      
      <p><strong>Available in thickness from 2mil - 16mil</strong></p>
    </section>
  </main>
);

export default SafetySecurityFilmsPage; 